import React, { Component } from 'react'
import * as validate from '../../util/validations';
import DeviceForm from '../presentation/DeviceManagement/DeviceForm'

class EditDevices extends Component {
    state = {
        formValues: {
            name: "",
            mobileNumber: "",
            serialNumber: "",
            imei: "",
            os: "",
            osVersion: "",
            model: "",
            deviceType: "",
            udid: "",
            identifier: "",
            trackingDevice: false,
            deviceId: "",
        },
        responseMessages: {
            error: false,
            errorField: "",
            success: "",
            serverError: ""
        },
        previousFormValues: {}
    }

    componentDidMount() {
        const deviceId = this.props.pageParameters && this.props.pageParameters[0]
        if (deviceId) { this.getDeviceDetails(deviceId)};
    }

    getDeviceDetails = (deviceId) => {
        fetch(`/service/getDeviceDetails?deviceId=${deviceId}`,
          {
            method: "GET",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json"
            },
            credentials: "same-origin"
          }
        ).then(response => {
          if (response.status === 200) {
            response.json().then(device => {
              const formValues = {
                deviceId,
                name: device.name,
                mobileNumber: device.mobileNumber,
                serialNumber: device.serialNumber,
                imei: device.imei,
                os: device.os,
                osVersion: device.osVersion,
                model: device.model,
                deviceType: device.deviceType,
                udid: device.udid,
                identifier: device.identifier,
                trackingDevice: device.trackingDevice
              }

              this.setState({formValues});
            });
          }
        }).catch(error => console.error('Error getting Device details', error));
    };

    updateDeviceState = e => {
        let { formValues } = { ...this.state };
        if (e.target.name === "trackingDevice") {
          formValues[e.target.name] = !formValues.trackingDevice;
        } else {
          formValues[e.target.name] = e.target.value;
        }
        this.setState({ formValues });
    };

    validateForm = () => {
        const { name, mobileNumber, serialNumber, imei, os, osVersion, model, deviceType } = this.state.formValues

        if (validate.required(name)) {
          this.setState({
            responseMessages: {
              error: "Please enter a device name",
              errorField: "name"
            }
          });
        } else if (validate.required(mobileNumber)) {
          this.setState({
            responseMessages: {
                error: "Please enter a mobile number ",
                errorField: "mobileNumber"
            }
          });
        } else if (validate.required(serialNumber)) {
          this.setState({
            responseMessages: {
              error: "Please enter a serial number",
              errorField: "serialNumber"
            }
          });
        } else if (validate.required(imei)) {
          this.setState({
            responseMessages: { error: "Please enter imei", errorField: "imei" }
          });
        } else if ( validate.required(os) || os === "Select OS" ) {
          this.setState({
            responseMessages: { error: "Please select OS", errorField: "os" }
          });
        } else if (validate.required(osVersion)) {
          this.setState({
            responseMessages: {
              error: "Please enter OS version",
              errorField: "osVersion"
            }
          });
        } else if (validate.required(model)) {
          this.setState({
            responseMessages: { error: "Please enter model", errorField: "model" }
          });
        } else if ( validate.required(deviceType) || deviceType === "Select Test device type") {
          this.setState({
            responseMessages: {
              error: "Please select a device type",
              errorField: "deviceType"
            }
          });
        } else {
          this.setState({ responseMessages: { error: false } });
          return true;
        }
      };

      handleEditDevice = () => {
        const body = { ...this.state.formValues };
    
        this.setState({ responseMessages: { serverError: "", success: "" } });
    
        if (this.validateForm()) {
          fetch("/service/editDevice", {
            method: "POST",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json"
            },
            credentials: "same-origin",
            body: JSON.stringify(body)
          }).then(response => {
            if (response.status !== 200) {
              response.json().then(json => {
                this.setState({
                responseMessages: {
                    serverError: json.errorMessage,
                    errorField: json.errorField,
                    success: ""
                  }
                });
              });
            } else {
              let { formValues } = this.state;
              // Clear error messages
              this.setState({
                responseMessages: {
                  success: "Device details updated successfully",
                  errorField: "",
                  serverError: ""
                },
                formValues,
                previousFormValues: { ...formValues }
              });
            }
          });
        }
      };
    
      handleAddDevice = () => {
        const body = {...this.state.formValues};
    
        this.setState({ editDeviceError: { serverError: "", success: "" } });
    
        if (this.validateForm()) {
          fetch("/service/createDevice", {
            method: "POST",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json"
            },
            credentials: "same-origin",
            body: JSON.stringify(body)
          }).then(response => {
            if (response.status !== 200) {
              response.json().then(json => {
                this.setState({
                responseMessages: {
                    serverError: json.errorMessage,
                    errorField: json.errorField,
                    success: ""
                  }
                });
              });
            } else {
              this.setState({
                responseMessages: {
                  success: "Device details updated successfully",
                  errorField: "",
                  serverError: ""
                }
              });
            }
          });
        }
    };

    deleteDevice = deviceId => {
        if (confirm("Are you sure you want to delete this device?")) {
          fetch("/service/deleteDevice", {
            method: "POST",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json"
            },
            credentials: "same-origin",
            body: JSON.stringify({ deviceId })
          }).then(response => {
            if (response.status === 200) {
                // Redirect to Device Management page
               this.props.navigator.requestDeviceManagement();
            }
          });
        }
      };

    render() {
        return <DeviceForm 
            editDevice={this.state.formValues} 
            handleAddDevice={this.handleAddDevice} 
            handleEditDevice={this.handleEditDevice} 
            updateDeviceState={this.updateDeviceState} 
            deleteDevice={this.deleteDevice}
            responseMessage={this.state.responseMessages}
            navigator={this.props.navigator}
        />
    }

}

export default EditDevices